/* eslint-disable require-await */
import ShopEntity from './base.js';

export default class Cart extends ShopEntity {

	static get NAME() {
		return 'Cart';
	}

	actions = {

		// Use base actions
		// @ts-ignore
		...this.actions,

		// Refresh cart section (counter + tooltip)
		/** @type {import('./base').ShopActionHandler} */
		update_cart_header: (args, actionType, res) => {
			mpro.actionHandlers.update_cart_header(args, actionType, res);
		},

		// Redirect to /cart_preview
		/** @type {import('./base').ShopActionHandler} */
		redirect_cart: () => {
			mpro.actionHandlers.redirect_cart();
		},

		// Redirect to /checkout
		/** @type {import('./base').ShopActionHandler} */
		redirect_checkout: () => {
			mpro.actionHandlers.redirect_checkout();
		},

		// Show cart preview in a modal
		/** @type {import('./base').ShopActionHandler} */
		cart_preview_modal: (args, actionType, res, triggerElement) => {
			mpro.actionHandlers.cart_preview_modal(args, actionType, res, triggerElement);
		},

		// Show last added item in a modal
		/** @type {import('./base').ShopActionHandler} */
		last_item_modal: (args, actionType, res, triggerElement) => {
			mpro.actionHandlers.last_item_modal(args, actionType, res, triggerElement);
		},

		// Show cart preview in a tooltip
		/** @type {import('./base').ShopActionHandler} */
		cart_preview_dropdown: () => {
			mpro.actionHandlers.cart_preview_dropdown();
		},

		// Show cart preview in side drawer
		/** @type {import('./base').ShopActionHandler} */
		cart_preview_drawer: (args, actionType, res, triggerElement) => {
			mpro.actionHandlers.cart_preview_drawer(args, actionType, res, triggerElement);
		},

		// Show last added item in side drawer
		/** @type {import('./base').ShopActionHandler} */
		last_item_drawer: (args, actionType, res, triggerElement) => {
			mpro.actionHandlers.last_item_drawer(args, actionType, res, triggerElement);
		},

		// Hide gift card form
		/** @type {import('./base').ShopActionHandler} */
		hide_gift_card_form: (args, actionType, res, triggerElement) => {
			mpro.actionHandlers.hide_gift_card_form(args, actionType, res, triggerElement);
		},
	};

	constructor() {
		super();
		// Assign the api
		this.api = mpro.ajax.cart;
	}

	get() {
		return this.api.get();
	}

	async add(data) {
		return this.api.add(data);
	}

	async update(data) {
		return this.api.update(data);
	}

	async modify(data) {
		return this.api.modify(data);
	}

	async addCoupon(data) {
		return this.api.addCoupon(data);
	}

	async deleteCoupon() {
		return this.api.deleteCoupon();
	}

	async setUserData(data) {
		return this.api.setUserData(data);
	}

	async setShippingMethod(data) {
		return this.api.setShippingMethod(data);
	}

	async setPaymentMethod(data) {
		return this.api.setPaymentMethod(data);
	}

	async clear() {
		return this.api.clear();
	}

	async checkout(data) {
		return this.api.checkout(data);
	}

	async processOrder(data) {
		return this.api.processOrder(data);
	}
}
